import { IonModal } from '@ionic/react';
import { useTheme } from 'styled-components';
import CardImageCropper from '../../../components/CardImageCropper';
import { useViewportHeight } from '../../../hooks/useViewportHeight';

const CardImageCropModal = ({ onClose, image, isPhysical = false, onComplete }) => {
  const theme = useTheme();
  const viewportHeight = useViewportHeight();

  if (!image) return null;

  return (
    <IonModal
      isOpen={true}
      onDidDismiss={onClose}
      backdropDismiss={false}
      canDismiss={false}
      cssClass="full-screen-crop-modal"
      style={{
        '--background': 'black',
        '--width': '100vw',
        '--height': viewportHeight,
      }}
    >
      <CardImageCropper
        image={image}
        isPhysical={isPhysical}
        onCancel={onClose}
        onComplete={onComplete}
      />
    </IonModal>
  );
};

export default CardImageCropModal;
